import { useState } from "react";
import emailjs from "emailjs-com";

const initialState = {
  name: "",
  email: "",
  message: "",
};
export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState({ ...initialState });

  const handleSubmit = (e) => {
    e.preventDefault();

    const recaptchaValue = window.grecaptcha.getResponse();
    if (!recaptchaValue) {
      alert("Please complete the CAPTCHA first.");
      return;
    }

    emailjs
      .sendForm(
        "service_jy8zj11",
        "template_f0q0eez",
        e.target,
        "9w4CPGRbr39HB39RS"
      )
      .then(
        (result) => {
          alert("Thank you for getting in touch!");
          clearState();
          e.target.reset();
          window.grecaptcha.reset();
        },
        (error) => {
          alert("Something went wrong. Please try again later.");
          console.log("Email failed:", error.text);
        }
      );
  };
  return (
    <div id="contact" className="text-center">
      <div className="contact-bg" />
      <div className="container">
        <div className="section-title">
          <h2>CONTACT US</h2>
          <p>Let's build Something Great</p>
          <div className="bar" />
        </div>
        <div className="row">
          <div className="col-md-7 mt">
            <form
              action="?"
              name="sentMessage"
              validate
              onSubmit={handleSubmit}
              className="contact-form"
            >
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Your Name</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      className="form-control"
                      placeholder="Name"
                      required
                      onChange={handleChange}
                    />
                    <p className="help-block text-danger"></p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Email Address</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      className="form-control"
                      placeholder="Email"
                      required
                      onChange={handleChange}
                    />
                    <p className="help-block text-danger"></p>
                  </div>
                </div>
              </div>
              <div className="form-group">
                <label>Message</label>
                <textarea
                  name="message"
                  id="message"
                  className="form-control"
                  rows="4"
                  placeholder="Tell us about your project..."
                  required
                  onChange={handleChange}
                ></textarea>
                <p className="help-block text-danger"></p>
              </div>
              <div
                className="g-recaptcha"
                data-sitekey="6Ld_yo0rAAAAADPZtBzYK--t9aWl_u_NAgHmMeGP"
              />
              <div id="success"></div>
              <button type="submit" className="btn btn-custom btn-lg">
                Send Message
              </button>
            </form>
          </div>
          <div className="col-md-5 mt">
            <div className="contact-box">
              <h3>Get in Touch</h3>

              <div className="contact-item-box">
                <div className="contact-icon-box">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-phone text-primary">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                  </svg>
                </div>
                <div>
                  <h4>Phone</h4>
                  <p>+91 9054541120</p>
                </div>
              </div>

              <div className="contact-item-box">
                <div className="contact-icon-box">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-mail text-primary">
                    <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                  </svg>
                </div>
                <div>
                  <h4>Email</h4>
                  <p>contact@akrivtech.com</p>
                </div>
              </div>

              <div className="contact-item-box">
                <div className="contact-icon-box">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-map-pin text-primary">
                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                </div>
                <div>
                  <h4>Location</h4>
                  <p>Gaurav Path, Pal, Surat, Gujarat, India 395009</p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div >
  );
};
